import { DataBean } from "../DataBean";

export class InvoiceFreightType extends DataBean {




    public async getInvoiceFreightTypeConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getInvoiceFreightTypeConstants_Number", [args]);
    }

}